import React, { Component } from "react";
import { connect } from "react-redux";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { toggleEditContentTabNameEditor } from "ContentActions";
import { fetchFeature } from "GeneralTabAction";
import { EDIT_CONTENT_ICON_NAME, DEVELOPMENT_TYPE } from "Constants";
import EditIconName from "./editIconName";
import AppIcons from "AppIcons";

export var HEADING_SPONSORS = "sponsor";
export var HEADING_SPEAKERS = "speaker";
export var HEADING_SCHEDULES = "schedule";
export var HEADING_MAPS = "maps";
export var HEADING_MESSAGES = "message";
export var HEADING_EXHIBITORS = "exhibitor";
export var HEADING_WEBVIEW = "webview";
export var HEADING_NEWS = "news";
export var HEADING_ABOUT = "about";
export var HEADING_SOCIAL = "social";
export var HEADING_GALLERY = "gallery";
export var HEADING_POLL = "polls";
export var HEADING_COMMUNITY = "community";
export var HEADING_SURVEY = "survey";
export var HEADING_GAMIFICATION = "gamification";
export var HEADING_ATTENDEE = "attendee";
export var HEADING_ADVERTISEMENT = "advertisement";

class ContentIcon extends Component {
  onClickEditName(e) {
    this.props.toggleEditContentTabNameEditor(true);
  }

  userAdditionCallback = () => {
    this.props.fetchFeature(this.props.session);
  };

  render() {
    var { heading, selectedTab } = this.props;
    var iconURL = `../../style/images/content-icons/content-${heading}-Selected.png`;
    var headingTitle = "";
    var subHeadingTitle = "";

    switch (heading) {
      case HEADING_SPONSORS:
        headingTitle = "Sponsors";
        subHeadingTitle = "Our Partners";
        break;
      case HEADING_SPEAKERS:
        headingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Instuctor" : "Speakers";
        subHeadingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Instuctor" : "Speakers";
        break;
      case HEADING_SCHEDULES:
        headingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Live Class" : "Schedules";
        subHeadingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Live Class" : "Schedules";
        break;
      case HEADING_MAPS:
        headingTitle = "Maps";
        subHeadingTitle = "Maps";
        break;
      case HEADING_MESSAGES:
        headingTitle = "Messages";
        subHeadingTitle = "Messages";
        break;
      case HEADING_EXHIBITORS:
        headingTitle = "Exhibitors";
        subHeadingTitle = "Exhibitors";
        break;
      case HEADING_NEWS:
        headingTitle = "News";
        subHeadingTitle = "News";
        break;
      case HEADING_WEBVIEW:
        headingTitle = "WebView";
        subHeadingTitle = "WebView";
        break;
      case HEADING_SOCIAL:
        headingTitle = DEVELOPMENT_TYPE === "koachify" ? "Activity" : "Social";
        // subHeadingTitle = DEVELOPMENT_TYPE === "koachify" ? "Activity" : "Social";
        break;
      case HEADING_ABOUT:
        headingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Platform Guide" : "Event Guide";
        subHeadingTitle =
          DEVELOPMENT_TYPE === "koachify" ? "Platform Guide" : "Event Guide";
        break;
      case HEADING_GALLERY:
        headingTitle = "Gallery";
        subHeadingTitle = "Gallery";
        break;
      case HEADING_POLL:
        headingTitle = "Polls";
        subHeadingTitle = "Polls";
        break;
      case HEADING_COMMUNITY:
        headingTitle = "Community";
        subHeadingTitle = "Community";
        break;
      case HEADING_SURVEY:
        headingTitle = "Survey";
        subHeadingTitle = "Survey";
        break;
      case HEADING_GAMIFICATION:
        headingTitle = "Gamification";
        subHeadingTitle = "Gamification";
        break;
      case HEADING_ATTENDEE:
        headingTitle = "Attendees";
        subHeadingTitle = "Attendees";
        break;
      case HEADING_ADVERTISEMENT:
        headingTitle = "Advertisements";
        subHeadingTitle = "Advertisements";
        break;
      default:
    }

    if (selectedTab) subHeadingTitle = selectedTab.displayname;

    // var iconNameEditor = "";
    // if (this.props.toEditIconName) {
    //   iconNameEditor = <EditIconName iconname={subHeadingTitle} />;
    // }

    return (
      <div className="content-icon-div">
        <div className="row m-0">
          <div className="col-sm-2 p-0">
            <div className="content-heading-icon">
              {/* <img src={iconURL} /> */}
              <div className={`content-icons`}>
                {heading === "gamification"
                  ? AppIcons[`content_${heading}`]
                  : AppIcons[heading]}
              </div>
            </div>
          </div>
          <div className="col-sm-10 pr-0" style={{ marginTop: -4 }}>
            {this.props.toEditIconName ? (
              <EditIconName
                tab={selectedTab}
                finishOperationsCallback={this.userAdditionCallback}
              />
            ) : (
              <div>
                <div
                  className="content-subheading-title"
                  style={{ marginBottom: 8 }}
                >
                  {subHeadingTitle}
                  {this.props.selectedTab ? (
                    <button
                      className="edit-mapname"
                      onClick={this.onClickEditName.bind(this)}
                    >
                      <img
                        className="i-custom-normal"
                        src="../../style/images/custom-icons/edit.svg"
                      />
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="content-heading-title">{headingTitle}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var selectedTab = state.contentDisplayItems.filter(
    (tab) => tab.bsClass === ownProps.heading
  )[0];

  return {
    session: state.session,
    toEditIconName: state.toEditIconName,
    selectedTab,
  };
}

export default connect(mapStateToProps, {
  toggleEditContentTabNameEditor,
  fetchFeature,
})(ContentIcon);
